<div
  class="dialog_wrap ride_status_modal ride_status_modal_main successMessage">
  @if (
    transactionEnequiry() &&
    (transactionEnequiry().enquiry_id ||
      transactionEnequiry().is_payment_pending === false)
  ) {
    <div class="content">
      <figure>
        <img [src]="assetsConst.ridecompleted" alt="ridecompleted" />
      </figure>
      <h2>{{ 'RidehasbeenCompleted' | translate }}</h2>

      @if (backToHome() === false) {
        <!-- Fare breakdown hidden: only the total is shown below.
        @if (
          transactionEnequiry().trip_status === 'ENDED' &&
          transactionEnequiry().accept_payment === 'ONLINE'
        ) {
          @let totaPnding =
            +transactionEnequiry().waiting_charge +
            +transactionEnequiry().waiting_sp_tax;

          <p class="fare_summary">
            (
            @if (
              +transactionEnequiry().fare -
                (totaPnding + +transactionEnequiry().sp_tax_amount) >
              0
            ) {
              {{ 'Fareprovider' | translate }}
              <span class="fare_amount" dir="ltr">
                <span>{{
                  +transactionEnequiry().fare -
                    totaPnding +
                    +transactionEnequiry().sp_tax_amount | number: '1.3-3'
                }}</span>
                <span>{{ transactionEnequiry().currency_code }}</span>
              </span>
              +
            }
            {{ 'LogibidServiceCharge' | translate }}
            <span class="fare_amount" dir="ltr">
              <span>{{
                +transactionEnequiry().commission_amount +
                  +transactionEnequiry().tax_amount -
                  +transactionEnequiry().loyalty_amount | number: '1.3-3'
              }}</span>
              <span>{{ transactionEnequiry().currency_code }}</span>
            </span>
            + {{ 'WaitingChargesApplied' | translate }}
            <span class="fare_amount" dir="ltr">
              <span>{{ totaPnding | number: '1.3-3' }}</span>
              <span>{{ transactionEnequiry().currency_code }}</span>
            </span>
            )
          </p>
        }
        -->

        <p class="pending_payment">
          {{ 'additionalPayment' | translate }}
          <span class="price">
            <span class="primary">
              <!-- extra charge on a booking paid online: only the driver's share (no Logibids commission) -->
              @if (
                transactionEnequiry().accept_payment === 'ONLINE' &&
                !transactionEnequiry().is_online_extra_charge
              ) {
                {{ transactionEnequiry().total_amount }}
              } @else {
                {{
                  +transactionEnequiry().fare +
                    +transactionEnequiry().sp_tax_amount | number: '1.3-3'
                }}
              }
            </span>
            <span class="currency">{{ user.currency_code }}</span>
          </span>
          <span class="isPending">
            {{ 'isPending' | translate }}
          </span>
        </p>

        <p class="primaryPaymnet">
          {{ 'additionalPaymentInfo1' | translate }}
        </p>
        <p class="primaryPaymnet payment_confirm">
          @if (transactionEnequiry().is_online_extra_charge) {
            {{ 'additionalPaymentInfoAck' | translate }}
          } @else {
            {{ 'additionalPaymentInfo2' | translate }}
          }
        </p>
      }
    </div>

    @if (backToHome() === false) {
      <div class="footer_call">
        <figure>
          <a [href]="'tel:' + (user.default_region.admin_phone || '')">
            <img [src]="assetsConst.callSPWaiting" alt="admin call" />
          </a>
        </figure>
        <div class="btn_full">
          <p-button
            class="btn primary"
            type="submit"
            label="{{ 'okayRide' | translate }}"
            [ngClass]="{ disable: buttonDisabled() }"
            [disabled]="buttonDisabled()"
            [link]="true"
            (click)="btn_route()" />
        </div>
      </div>
    } @else {
      <div class="btn_full btn_accept">
        <p-button
          class="btn primary"
          type="submit"
          label="{{ 'BackToHome' | translate }}"
          (click)="btn_home()" />
      </div>
    }
  }
</div>
